import { useMonitor } from '../use-monitor';

export function useMonitorAddIssueTemplatesFormLoad() {
  return useMonitor('add-issue-templates-form-load');
}
